import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { Get_TargetFunnel, Get_LeadIndicatorFunnel } from "../../services/userAPI";

import Funnel1 from "../../Images/funnel1.png";
import Funnel2 from "../../Images/funnel2.png";
import Funnel3 from "../../Images/funnel3.png";
import Funnel4 from "../../Images/funnel4.png";
import Funnel5 from "../../Images/funnel5.png";
import Funnel6 from "../../Images/funnel6.png";
import Funnel7 from "../../Images/funnel7.png";
import Funnel8 from "../../Images/funnel8.png";
import Funnel9 from "../../Images/funnel9.png";
import Funnel10 from "../../Images/funnel10.png";
import Funnel11 from "../../Images/funnel11.png";
import Funnel12 from "../../Images/funnel12.png";
import Funnel13 from "../../Images/funnel13.png";
import Funnel14 from "../../Images/funnel14.png";
import Funnel15 from "../../Images/funnel15.png";
import Funnel16 from "../../Images/funnel16.png";
import Funnel17 from "../../Images/funnel17.png";
import Funnel18 from "../../Images/funnel18.png";
import Funnel19 from "../../Images/funnel19.png";
import Funnel20 from "../../Images/funnel20.png";

import Redline from "../../Images/red-line1.png";
import { Tooltip } from "antd";

const funnelImages = [
    Funnel1, Funnel2, Funnel3, Funnel4, Funnel5, Funnel6, Funnel7, Funnel8, Funnel9, Funnel10,
    Funnel11, Funnel12, Funnel13, Funnel14, Funnel15, Funnel16, Funnel17, Funnel18, Funnel19, Funnel20
];

const RoleTargetFunnelPreview = ({
    onBack,
    onNext,
    targetData,
    roleId,
    accountId
}) => {
    // Fetch data from API
    const { data, loading, error } = useQuery(Get_TargetFunnel, {
        variables: { roleId: roleId },
        skip: !roleId,
        fetchPolicy: "network-only",
    });

    if (error) console.error("❌ GraphQL API Error:", error);

    const [stages, setStages] = useState([]);
    const [leadStages, setLeadStages] = useState([]);

    // Fetch lead indicator data from API
    const { data: leadData, loading: leadLoading, error: leadError } = useQuery(Get_LeadIndicatorFunnel, {
        variables: { roleId: roleId },
        skip: !roleId,
        fetchPolicy: "network-only",
    });

    if (leadError) console.error("❌ Lead Indicator API Error:", leadError);

    // Update stages when API data is available
    useEffect(() => {
        if (data?.getKpisForRole && data.getKpisForRole.length > 0) {
            const reversedData = [...data.getKpisForRole].reverse(); // Reverse only the data
            const updatedStages = reversedData.map((item, index) => ({
                id: item.id,
                name: item.name,
                target: item.defaultValue,
                funnel: index < 7 ? funnelImages[index] : funnelImages[6],
            }));
            setStages(updatedStages);
        } else if (targetData?.targets && targetData.targets.length > 0) {
            const reversedData = [...targetData.targets].reverse(); // Reverse only the data
            const updatedStages = reversedData.map((item, index) => ({
                id: item.id,
                name: item.name,
                target: item.monthly,
                funnel: index < 7 ? funnelImages[index] : funnelImages[6],
            }));
            setStages(updatedStages);
        }
    }, [data, targetData]);

    // Update lead indicator stages when API data is available
    useEffect(() => {
        if (leadData?.getKiisForRole && leadData.getKiisForRole.length > 0) {
            const reversedData = [...leadData.getKiisForRole].reverse();
            const updatedStages = reversedData.map((item, index) => ({
                id: item.id,
                name: item.name,
                dailyTarget: item.dailyTarget,
                monthlyTarget: item.defaultValue,
                funnel: index < 7 ? funnelImages[index] : funnelImages[6],
            }));
            setLeadStages(updatedStages);
        }
    }, [leadData]);

    // Handle input change
    const handleInputChange = (index, key, value) => {
        const updatedStages = [...stages];
        updatedStages[index][key] = value;
        setStages(updatedStages);
    };

    const handleLeadInputChange = (index, key, value) => {
        const updatedStages = [...leadStages];
        updatedStages[index][key] = value;
        setLeadStages(updatedStages);
    };

    // Loading and error handling
    if (loading) return <p>Loading...</p>;

    const handleProceed = () => {
        if (onNext) {
            onNext({ roleId, targetFunnelName: data?.getTargetFunnel?.name });
        }
    };

    return (
        <div className="w-full">
            <div className="mx-auto flex w-full max-w-[1200px] flex-col">
                <div className="w-full rounded-[6px] border border-[#dedede] bg-white p-8 shadow-[0_1px_3px_rgba(0,0,0,0.06)]">
                    <span className="flex items-center justify-center text-[20px] font-bold">Target Funnel Preview</span>
                    <div className="flex w-full flex-col items-stretch">

                        <div className="mb-[-46px] ml-[60%] flex items-center">
                            <div className="flex w-[300px] flex-row justify-between">
                                <div className="mr-5">Stages</div>
                                <div className="mr-5">Targets <br />(Monthly)</div>
                            </div>
                        </div>

                        {stages.length > 0 ? (
                            stages.map((stage, index) => (
                                <div
                                    key={index}
                                    className={`grid grid-cols-[250px_60px_1fr] items-center ${index === stages.length - 1 ? "mb-0" : "mb-[-78px]"}`}
                                >
                                    {/* Funnel Image */}
                                    <div className="col-start-1 flex h-[120px] justify-start overflow-visible">
                                        <img src={stage.funnel} alt={`Funnel stage ${index + 1}`} className="h-full w-full max-w-[250px] object-none" />
                                    </div>

                                    <div className="col-start-2 flex h-[20px] w-full items-center justify-center pt-[10px]">
                                        <img src={Redline} alt="Red line separator" className="h-full w-full object-contain" />
                                    </div>

                                    {/* Input Fields */}
                                    <div className="relative z-[1] col-start-3 flex items-center gap-[10px] pt-[15px]">
                                        <Tooltip title={stage.name}>
                                            <input
                                                type="text"
                                                className="w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap rounded-[5px] border border-[#ccc] px-3 py-2 leading-[1.4] outline-none"
                                                value={stage.name}
                                                readOnly
                                            />
                                        </Tooltip>
                                        <input
                                            type="number"
                                            className="rl-funnel-num-input box-border h-[40px] w-[30%] rounded-[5px] border border-[#ccc] px-3 py-2 text-center outline-none"
                                            value={stage.target}
                                            onChange={(e) => handleInputChange(index, "target", e.target.value)}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="mt-6">No funnel data available.</p>
                        )}
                    </div>

                    <span className="mt-[40px] flex items-center justify-center text-[20px] font-bold">Lead Indicator Preview</span>
                    <div className="flex w-full flex-col items-stretch">

                        <div className="mb-[-46px] grid grid-cols-[250px_60px_1fr] items-end">
                            <div></div>
                            <div></div>
                            <div className="flex items-end gap-[10px] pt-[10px]">
                                <div className="flex-1 text-center">Stages</div>
                                <div className="w-[15%] text-center">Daily<br />Norm</div>
                                <div className="w-[20%] text-center">Targets<br />(Monthly)</div>
                            </div>
                        </div>

                        {leadStages.length > 0 ? (
                            leadStages.map((stage, index) => (
                                <div
                                    key={index}
                                    className={`grid grid-cols-[250px_60px_1fr] items-center ${index === leadStages.length - 1 ? "mb-0" : "mb-[-78px]"}`}
                                >
                                    <div className="col-start-1 flex h-[120px] justify-start overflow-visible">
                                        <img src={stage.funnel} alt={`Funnel stage ${index + 1}`} className="h-full w-full max-w-[250px] object-none" />
                                    </div>

                                    <div className="col-start-2 flex h-[20px] w-full items-center justify-center pt-[10px]">
                                        <img src={Redline} alt="Red line separator" className="h-full w-full object-contain" />
                                    </div>

                                    <div className="relative z-[1] col-start-3 flex items-center gap-[10px] pt-[15px]">
                                        <Tooltip title={stage.name}>
                                            <input
                                                type="text"
                                                className="w-full cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap rounded-[5px] border border-[#ccc] px-3 py-2 leading-[1.4] outline-none"
                                                value={stage.name}
                                                readOnly
                                            />
                                        </Tooltip>
                                        <input
                                            type="number"
                                            className="rl-funnel-num-input box-border h-[40px] w-[30%] rounded-[5px] border border-[#ccc] px-3 py-2 text-center outline-none"
                                            value={stage.dailyTarget}
                                            onChange={(e) => handleLeadInputChange(index, "dailyTarget", e.target.value)}
                                            readOnly
                                        />
                                        <input
                                            type="number"
                                            className="rl-funnel-num-input box-border h-[40px] w-[30%] rounded-[5px] border border-[#ccc] px-3 py-2 text-center outline-none"
                                            value={stage.monthlyTarget}
                                            onChange={(e) => handleLeadInputChange(index, "monthlyTarget", e.target.value)}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="mt-6">No lead indicator data available.</p>
                        )}
                    </div>

                </div>
                <div className="mt-5 flex justify-end gap-5">
                    <button
                        className="flex h-[42px] w-[80px] cursor-pointer items-center justify-center rounded-[6px] bg-[#AD0101] text-[15px] font-normal text-white transition-colors"
                        onClick={handleProceed}
                    >
                        Proceed
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RoleTargetFunnelPreview;
